import React from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import styles from "./SignIn.module.css";

export default function SuccessScreen() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <div className={styles.box}>
        <IoMdCheckmarkCircleOutline size={150} color="#66D6FF" />
        <h5 style={{ fontFamily: "Inter, sans-serif", marginTop: 10 }}>
          Success!
        </h5>
        <p
          style={{
            textAlign: "center",
            color: "#B6B6B6",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Congratulations! You have been<br></br> successfully authenticated
        </p>

        <buttton
          style={{
            width: "90%",
            height: 55,
            background: "#07448E",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            fontFamily: "Inter, sans-serif",
          }}
        >
          CONTINUE
        </buttton>
      </div>
    </div>
  );
}
